// ═══════════════════════════════════════════════════════════════════
//  modules/erp/SkinRender.js
//  SkinRender
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";

// ── Rendu du skin (compte premium via proxy → vrai skin par UUID) ─────
export function SkinRender({ uuid, username }) {
  const candidates = [
    `https://mc-heads.net/body/${uuid}`,                  // fiable
    `https://visage.surgeplay.com/full/256/${uuid}`,      // 3D, secours
    `https://crafatar.com/renders/body/${uuid}?overlay`,  // secours
    `https://mc-heads.net/body/MHF_Steve`,                // défaut garanti
  ];
  const [idx, setIdx] = useState(0);
  if (idx >= candidates.length) {
    return <div style={{ width: 80, height: 160, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40 }}>🧍</div>;
  }
  return (
    <img
      src={candidates[idx]}
      alt={username}
      onError={() => setIdx((i) => i + 1)}
      style={{ width: 80, imageRendering: "pixelated", borderRadius: 4 }}
    />
  );
}
